import React from 'react';
import { Button } from '../ui/Button';
import { Check } from 'lucide-react';
export function PriceSection() {
  return <section id="precio" className="py-20 bg-slate-900 text-white overflow-hidden relative" data-id="element-107">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" data-id="element-108"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-109">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl overflow-hidden shadow-2xl flex flex-col md:flex-row" data-id="element-110">
          <div className="p-8 md:p-12 md:w-2/3 text-slate-900" data-id="element-111">
            <h2 className="text-3xl font-bold mb-4" data-id="element-112">
              Oferta Especial Limitada
            </h2>
            <p className="text-slate-600 mb-8" data-id="element-113">
              Obtén acceso inmediato a todo el sistema. Descarga digital
              instantánea.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-114">
              <li className="flex items-center gap-3" data-id="element-115">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-116">
                  <Check className="w-5 h-5 text-green-600" data-id="element-117" />
                </div>
                <span className="font-medium" data-id="element-118">
                  El Protocolo Sombrilla (PDF)
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-119">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-120">
                  <Check className="w-5 h-5 text-green-600" data-id="element-121" />
                </div>
                <span className="font-medium" data-id="element-122">
                  Plantillas Legales Editables
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-123">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-124">
                  <Check className="w-5 h-5 text-green-600" data-id="element-125" />
                </div>
                <span className="font-medium" data-id="element-126">
                  Video Curso "La Carpeta Roja"
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-127">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-128">
                  <Check className="w-5 h-5 text-green-600" data-id="element-129" />
                </div>
                <span className="font-medium" data-id="element-130">
                  Acceso de por vida + Actualizaciones
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-slate-100 p-8 md:p-12 md:w-1/3 flex flex-col justify-center items-center border-t md:border-t-0 md:border-l border-slate-200" data-id="element-131">
            <div className="text-slate-500 line-through text-lg mb-1" data-id="element-132">
              Valor Real: $394
            </div>
            <div className="text-slate-400 line-through text-base mb-1" data-id="element-133">
              Precio regular: $37
            </div>
            <div className="text-5xl font-extrabold text-slate-900 mb-2" data-id="element-134">
              $6.39
            </div>
            <div className="text-green-600 font-bold text-sm mb-6 bg-green-100 px-3 py-1 rounded-full" data-id="element-135">
              AHORRAS 98% HOY
            </div>

            <Button variant="primary" fullWidth size="lg" className="shadow-xl shadow-red-500/20 animate-pulse hover:animate-none" onClick={() => window.open('https://claridaddiaria.com/cart/43017627009090:1', '_blank')} data-id="element-136">
              COMPRAR AHORA
            </Button>

            <div className="mt-4 flex items-center gap-2 text-xs text-slate-500" data-id="element-137">
              <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-138"></div>
              Pago Seguro 256-bit SSL
            </div>
          </div>
        </div>
      </div>
    </section>;
}